import { mainApiSlice } from "../api/mainApiSlice";
import { API_BASE_URL } from "../../../configurations/configurations";

export const faqApi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFaqsByAdminId: builder.query({
      query: ({ adminId }) => ({
        url: `${API_BASE_URL}/faq/${adminId}`,
        method: "GET",
      }),
      providesTags: (result) => {
        if (result && Array.isArray(result)) {
          return [
            ...result.map(({ id }) => ({
              type: "Faq",
              id,
            })),
            { type: "FaqList", id: "LIST" },
          ];
        }
        return [{ type: "FaqList", id: "LIST" }];
      },
    }),
    createFaq: builder.mutation({
      query: ({ adminId, faq }) => ({
        url: `${API_BASE_URL}/faq/${adminId}`,
        method: "POST",
        body: faq,
      }),
      invalidatesTags: (result, error, faq) => [
        { type: "FaqList", id: "LIST" },
      ],
    }),
    updateFaqById: builder.mutation({
      query: ({ adminId, faqId, faq }) => ({
        url: `${API_BASE_URL}/faq/${adminId}/${faqId}`,
        method: "PUT",
        body: faq,
      }),
      invalidatesTags: (result, error, { faqId }) => [
        { type: "Faq", id: faqId },
        { type: "FaqList", id: "LIST" },
      ],
    }),
    deleteFaqById: builder.mutation({
      query: ({ adminId, faqId }) => ({
        url: `${API_BASE_URL}/faq/${adminId}/${faqId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { faqId }) => [
        { type: "Faq", id: faqId },
        { type: "FaqList", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetFaqsByAdminIdQuery,
  useCreateFaqMutation,
  useUpdateFaqByIdMutation,
  useDeleteFaqByIdMutation,
} = faqApi;
